import { formatPercent } from './formatPercent';
import { formatMoney } from './money/formatMoney';

/** Pesos as the home writes every figure: "$1.565.700" under es-CL. */
export const clp = (value: number, locale: string) => formatMoney(value, 'CLP', locale);

/**
 * A percentage as the home writes it. Spanish separates the sign with a
 * non-breaking space ("33 %"), which es-CL's Intl output leaves out.
 */
export const percent = (value: number, locale: string, digits = 1, minDigits = digits) => {
  const text = formatPercent(value, locale, digits, minDigits);
  return locale.startsWith('es') ? text.replace(/(\d)%/, '$1 %') : text;
};

// Past this, a savings rate comes from an income too small to mean anything, and outgrows its column.
const RATE_LIMIT = 999;

/**
 * A savings rate as the landing's savings chart writes it, with the sign against
 * the figure ("28%"): a true minus for an overspent month, and bounded past the
 * limit ("<−999%"), where a tiny income makes the figure meaningless.
 */
export const savingsRateText = (value: number, locale: string, digits = 0) => {
  if (value < -RATE_LIMIT) return `<−${formatPercent(RATE_LIMIT, locale, 0)}`;
  return `${value < 0 ? '−' : ''}${formatPercent(Math.abs(value), locale, digits, digits)}`;
};

/** Months of coverage, one decimal at most: "1,5", "6". */
export const monthCount = (value: number, locale: string) =>
  value.toLocaleString(locale, { maximumFractionDigits: 1 });
